export default __webpack_public_path__ + "static/karting-intro-04f10de7f39cf6fa4b86cf5c38ce1a64.svg";